interface LinkedinProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const Linkedin = ({ className = '', ...props }: LinkedinProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 29.66 29.66"
      fill="none"
      className={className}
      {...props}
    >
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          fill="currentColor"
          d="M6.59,3.3c0,1.81-1.15,3.3-3.3,3.3-1.98,0-3.3-1.48-3.3-3.13C0,1.65,1.32,0,3.3,0s3.3,1.48,3.3,3.3Z"
        />
        <rect fill="currentColor" y="8.24" width="6.59" height="21.42" />
        <path
          fill="currentColor"
          d="M22.41,8.57c-3.46,0-5.44,1.98-6.26,3.3h-.16l-.33-2.8h-5.93c0,1.81.16,3.95.16,6.43v14.17h6.59v-11.7c0-.66,0-1.15.16-1.65.49-1.15,1.32-2.64,3.13-2.64,2.31,0,3.3,1.98,3.3,4.61v11.37h6.59v-12.19c0-6.1-3.13-8.9-7.25-8.9Z"
        />
      </g>
    </svg>
  );
};

export default Linkedin;
